var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper login-wrapper"},[_c('div',{staticClass:"container-wide flex-col",class:_vm.$store.state.auth.loggedIn &&
      !_vm.$store.state.userData.user.is_email_verified
        ? 'mt-12'
        : ''},[(!_vm.$store.state.auth.status.loggedIn)?_c('div',{staticClass:"flex flex-col w-7/12 mobile:w-full mx-auto mt-12 register-container p-12 mobile:p-6 mb-8 relative"},[_c('registration-form-join')],1):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }